import { supportedPreviewFormats } from "./helpers.js";

const createPreview = async (file, type) => {
  const blobURL = supportedPreviewFormats.includes(type)
    ? URL.createObjectURL(file)
    : null;

  const cleanup = () => {
    if (blobURL) {
      URL.revokeObjectURL(blobURL);
    }
  };

  // Cleanup when the blob URL is no longer needed
  setTimeout(cleanup, 1000);

  return blobURL;
};

export default createPreview;
